import { useEffect, useRef, useState } from "react";
import { Tooltip } from "@primer/react";
import { PackageIcon } from "@primer/octicons-react";
import "../IdentityLink/IdentityLink.css";
import "./AssetIdentity.css";

export function assetHref(assetId) {
  return `#/assets/${encodeURIComponent(assetId)}`;
}

export function AssetIdentity({ asset, copyableTicker = true, expanded, href, onSelect, trailing, variant = "compact" }) {
  const Target = href ? "a" : onSelect ? "button" : "span";
  const targetProps = href
    ? { href }
    : onSelect
      ? { "aria-expanded": expanded, onClick: onSelect, type: "button" }
      : {};

  return (
    <span className={`${variant} asset-identity`}>
      <Target className="asset-target identity-link" {...targetProps}>
        <PackageIcon aria-hidden="true" />
        <strong className="identity-link-label">{asset.name || asset.id}</strong>
      </Target>
      {copyableTicker ? <AssetTicker assetId={asset.id} /> : <span className="ticker-control"><span className="asset-ticker static">{asset.id}</span></span>}
      {trailing ? <span className="trailing">{trailing}</span> : null}
    </span>
  );
}

export function AssetTicker({ assetId }) {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef(null);

  useEffect(() => () => window.clearTimeout(resetTimer.current), []);

  async function copyTicker() {
    try {
      await navigator.clipboard.writeText(assetId);
      setCopied(true);
      window.clearTimeout(resetTimer.current);
      resetTimer.current = window.setTimeout(() => setCopied(false), 1400);
    } catch {
      setCopied(false);
    }
  }

  return (
    <span className="ticker-control">
      <Tooltip text={copied ? "Copied" : "Copy ticker"} direction="s">
        <button className="asset-ticker" type="button" aria-label={`Copy ticker ${assetId}`} onClick={copyTicker}>{assetId}</button>
      </Tooltip>
    </span>
  );
}
